import React, { useEffect, useState, useContext } from 'react';
import { Button, Form, Popconfirm, Table, Select, Layout, Tag, InputNumber, Modal } from "antd";
import { getGridTableHeight } from '../Common/util';
import { excelDownload, EditableCell, EditableRow } from '../Common/function';
import { getAssetTypeValue } from '../Common/options.js';
import axios from '../Common/axios';
import Papa from "papaparse";
import { postSaveTemplateUpload } from '../Common/api';
import AppContext from '../../components/AppContext';

const { Content } = Layout;
const { Option } = Select;

/** -------------------------------------------------------------------------- **/
const InfoTableAsset = ({ data, columnData, rowIndex,selectedRowKeys, setSelectedRowKeys, reportId, reportInfo, infoType, isLoading, onClickSaveHandler, onReloadHandler, assetTypeOrg}) => {
    const myContext = useContext(AppContext);
    //console.log(myContext);

    const [assetGradeHigh, setAssetGradeHigh] = useState(myContext.assetGradeHigh);  //7이상이면 High
    const [assetGradeRow, setAssetGradeRow] = useState(myContext.assetGradeRow);    //4이하이면 Row

    const [DOAHigh, setDOAHigh] = useState(12);  //12이상이면 High
    const [DOARow, setDOARow] = useState(5);    //4이하이면 Row

    // 변수 선언
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [deleteData, setDeleteData] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    // State to store parsed data
    const [parsedData, setParsedData] = useState([]);
    //State to store table Column name
    const [tableRows, setTableRows] = useState([]);
    //State to store the values
    const [values, setValues] = useState([]);
    const confirmed = reportInfo.confirm === 'Y' ? true : false;
    const created_ymd = (reportInfo.created_ymd === '' || reportInfo.created_ymd === null) ? true : false;
    // const [changeData, setChangeData] = useState([]);

    let changeData = [];
    const excel_title = '자산';
    const idNumberCount = 2;

    // rowSelection 설정
    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys) => {
            setSelectedRowKeys(newSelectedRowKeys);
        },
    };


    let titleName="자산 등록";
    let cdName = infoType + "_cd";
    /** -------------------------------------------------------------------------- **/
    useEffect(() => {
        setDataSource(data);
        setDeleteData([]);
        // setChangeData([]);
        changeData=[];
    }, [data]);

    const operationColumns = [
        {
            key: 'operation',
            width: '0px',
            defualt: '',
        },
        {
            title: 'delete',
            width: '100px',
            align: 'center',
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.id, record[cdName])}>
                        <a>Delete</a>
                    </Popconfirm>
                ) : null,
        },
    ];

    // 미확정상태의 경우 operation칼럼 추가 및 edit기능 추가
    let mergedColumns = [];

    // 취약점 진단 하면 최초 진단날짜를 확인해 자산 수정 못하게 막음 
    if (!confirmed && created_ymd) {
       
        const columns = [...columnData];
        operationColumns.map((col) => {
            if(infoType==="asset" || infoType==="corrective") columns.push(col);
        });

        mergedColumns = columns.map((col) => {

            if (!col.editable) { return col; }
            let i=0;
            return {
                ...col,
                onCell: (record) => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    tabIndex: 0,
                    handleSave,
                }),
            };
        });
    } else {
        mergedColumns = [...columnData];
    }

    // 선택된 항목 삭제
    const handleDeleteSelected = () => {
        const newData = dataSource.filter((item) => !selectedRowKeys.includes(item.asset_cd));
        const delData = dataSource.filter((item) => selectedRowKeys.includes(item.asset_cd) && item.id !== 0);
        
        // 삭제 대상에 operation 'D' 추가
        const deletedItems = delData.map(item => ({
            ...item,
            operation: 'D'
        }));

        if(newData.length < 1){
            Modal.info({ title:titleName, content:"최소 한개 자산은 있어야 합니다.", okText: "Close" });
            return;
        }
        setDataSource(newData);
        setDeleteData(deleteData.concat(deletedItems));
        setSelectedRowKeys([]);
    };
    
    // 행 추가
    const handleAdd = () => {
        let newData;
        // 권고사항은 suggest 가 아닌 measure_cd로 넘어 오고 있으므로 주의 
        let cdType = infoType + "_type";

        // 자동으로 코드 값을 만들어 적용하는 분분
        // let test = dataSource.
        let len = dataSource.length;
        let maxValue = "";
        let assetType = "";
        let cdName = infoType + "_cd";

        if(len > 0 ){

            for (let i = 0; len > i; i++) {
                maxValue = dataSource[i][cdName] > maxValue ? dataSource[i][cdName] : maxValue;
            }

            assetType = dataSource[len-1][cdType];
            let regex = /(.+?)([0-9]+)$/;
            let [tempRow, maxValueName, maxValueNumTemp] = maxValue.match(regex);
            let maxValueNumLen = maxValueNumTemp.length;
            let maxValueNum = Number(maxValueNumTemp) + 1;
            let zeroVal = maxValueNum.toString().padStart(maxValueNumLen, '0');
            let maxValueStr = maxValueName + zeroVal;
            let copyVal = dataSource[0];

            newData = {
                operation: 'C',
                id: 0,
                report_id: reportId,
                // com_cd: '',
                asset_type: assetType,
                asset_cd: maxValueStr,
                asset_nm: copyVal.asset_nm,
                asset_ip: '',
                asset_spec: copyVal.asset_spec,
                asset_ver: '',
                os_ver: '',
                service_nm: copyVal.service_nm,
                location_nm: copyVal.location_nm,
                // depart_nm:'',
                manager_nm: copyVal.manager_nm,
                supervisor_nm: copyVal.supervisor_nm,
                mac_no: '',
                ssh_port: copyVal.ssh_port,
                arch: '',
                cpu: '',
                confidential_score: copyVal.confidential_score,
                integrity_score: copyVal.availability_score,
                availability_score: copyVal.availability_score,
                asset_grd: copyVal.asset_grd,
                asset_rnk: copyVal.asset_rnk,
            };
        }else{
            const assetTypeValue = getAssetTypeValue();
            maxValue = assetTypeOrg+'001';
            newData = {
                operation: 'C',
                id: 0,
                // com_cd: companyCode,
                asset_type: assetTypeOrg,
                asset_cd: maxValue,
                asset_nm: '',
                asset_ip: '',
                asset_spec : assetTypeValue[assetTypeOrg][1],
                asset_ver: '',
                os_ver: '',
                service_nm: '',
                location_nm: '',
                // depart_nm: '',
                manager_nm: '',
                supervisor_nm: '',
                mac_no: '',
                ssh_port: '22',
                arch: '',
                cpu: '',
                confidential_score: 3,
                integrity_score: 3,
                availability_score: 3,
                asset_grd: 'H',
                asset_rnk: 3,
            }               
        }
        setDataSource([...dataSource, newData]);
    };

    // 행 삭제
    const handleDelete = (key, kindCd) => {
        if(dataSource.length < 2){
            Modal.info({ title:titleName, content:"최소 한개 자산은 있어야 합니다.", okText: "Close" });
            return;
        }
        const newData = dataSource.filter((item) => item[cdName] != kindCd);
        setDataSource(newData);

        if (key != 0) {
            const delData = dataSource.filter((item) => item.id == key);
            delData[0].operation = 'D';
            setDeleteData(deleteData.concat(delData));
        }
    };
    // 행 삭제
    // const handleDelete = (key) => {
    //     const newData = dataSource.filter((item) => item.id != key);
    //     setDataSource(newData);

    //     if (key != 0) {
    //         const delData = dataSource.filter((item) => item.id == key);
    //         delData[0].operation = 'D';
    //         setDeleteData(deleteData.concat(delData));
    //     }
    // };

    //행 저장
    const handleSave = (row) => {
        //비교를 위하여 깊은 복사 실행
        const newData = JSON.parse(JSON.stringify(dataSource));
        let index=0;

        if(row.id>0){
            index = newData.findIndex((item) => row["id"] === item["id"]);
        }else{
            index = newData.findIndex((item) => row[cdName] === item[cdName]);
            if( index == -1 ){
                Modal.info({ title:titleName, content:"새로 생성된 값 중에서 다른 값은 수정 가능하나 \n'코드' 값은 바로 수정이 되지 않습니다. \n한번 저장(save)하시고 수정해 주시기 바랍니다.", okText: "Close" });
                return;
            }
        }

        const item = newData[index];
    
        //보안등급, 자산평가 계산
        let confidential = row.confidential_score ? parseInt(row.confidential_score) : 0;
        let integrity = row.integrity_score ? parseInt(row.integrity_score) : 0;
        let availability = row.availability_score ? parseInt(row.availability_score) : 0;
        let score_sum = confidential + integrity + availability;

        if (score_sum >= assetGradeHigh) {
            row.asset_grd = 'H';
            row.asset_rnk = 3;
        } else if (score_sum > assetGradeRow) {
            row.asset_grd = 'M';
            row.asset_rnk = 2;
        } else {
            row.asset_grd = 'L';
            row.asset_rnk = 1;
        }

        if (JSON.stringify(item) != JSON.stringify(row)) {
            row.operation = row.id == '0' ? 'C' : 'U';
            newData.splice(index, 1, {
                ...item,
                ...row,
            });

            setDataSource(newData);
        }
    };

    useEffect(() => {

        //저장,수정 대상 추가
        const newData = dataSource.filter((item) => item.operation && item.operation != '');
        changeData = [];

        newData.map((record) => {
          if(record.operation && record.operation != '') {
            changeData = changeData.concat(record);
          }
        })
        
        // setChangeData(newData);

    }, [dataSource]);

    /** -------------------------------------------------------------------------- **/
    // 파일업로드
    const onChangeUploadHandler = (event) => {

        setShowUpload(true);
        setIsDataChange(false);
        // Passing file data (event.target.files[0]) to parse using Papa.parse
        Papa.parse(event.target.files[0], {
            header: true,
            skipEmptyLines: 'greedy',
            complete: function (results) {
                const rowsArray = [];
                const valuesArray = [];

                // Iterating data to get column name and their values
                results.data.map((d) => {
                    rowsArray.push(Object.keys(d));
                    valuesArray.push(Object.values(d));
                });

                // Parsed Data Response in array format
                setParsedData(results.data);

                // Filtered Column Names
                setTableRows(rowsArray[0]);

                // Filtered Values
                setValues(valuesArray);
            },
        });
    };


    // 파일업로드 저장
    const onClickFileSaveHandler = () => {

        setUploading(true);
        setIsDataChange(false);
        axios.post(postSaveTemplateUpload(), {
            reportId: reportId,
            infoType: infoType,
            parsedData: parsedData,
        }, { logType: '/create/VaBaseUpload/', logCompany: reportInfo.com_cd, logParam: reportId })
            .then((response) => {
                //console.log(response);
                setUploading(false);
                //Modal.info({title: "OK.", okText:"Close"});
                if (response.data == '000') {
                    Modal.info({title:titleName, content:"업로드가 정상적으로 적용되었습다.", okText: "Close", onOk() {
                            // 분석기준 재조회
                            onReloadHandler();
                            setShowUpload(false);
                        }
                    });
                } else {
                    Modal.info({ title:titleName, content:response.data, okText: "Close" });
                }
            })
            .catch((error) => {
                setUploading(false);
                Modal.error({ title:titleName, content:error.message, okText: "Close" });
            });
    };

    // 정보 변경시 재조회
    useEffect(() => {
        if (isDataChange) {
            setDataSource();
        }
    }, [isDataChange]);

    /** -------------------------------------------------------------------------- **/
    // 보안등급 변경
    const onChangeGradeHigh = (value) => {
        setAssetGradeHigh(value);
    };
    const onChangeGradeRow = (value) => {
        setAssetGradeRow(value);
    };

    //보안등급 재설정
    const handleGrade = () => {
        dataSource.map((row) => {
            handleSave(row);
            //재계산 처리시에 적용함
            myContext.setAssetGradeHigh(assetGradeHigh);
            myContext.setAssetGradeRow(assetGradeRow);
        })
        Modal.info({ title:titleName, content:"변경된 등급은 Save를 클릭해야만 DB에 저장됩니다.", okText: "Close" });
    }

    /** -------------------------------------------------------------------------- **/
    // DOA 변경
    const onChangeDOAHigh = (value) => {
        setDOAHigh(value);
    };
    const onChangeDOARow = (value) => {
        setDOARow(value);
    };

    //DOA 재설정
    const handleDOA = () => {
        //dataSource.map((row) => {
        //    handleSave(row);
        //재계산 처리시에 적용함
        //myContext.setDOAHigh(DOAHigh);
        //myContext.setDOARow(DOARow);
        //})
        Modal.info({ title:titleName, content:"변경된 등급은 Save를 클릭해야만 DB에 저장됩니다.", okText: "Close" });
    }

    const saveData = () => {
        const result = onClickSaveHandler(changeData.concat(deleteData));
        if(result){
            setDeleteData([]);
            // setChangeData([]);
            changeData=[];
        }
    }
    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <table style={{ width: '100%' }}><tbody>
                <tr>
                    <td><div style={{ marginLeft: '20px' }}>총 {dataSource?.length} 개</div></td>
                    <td style={{ textAlign: 'right' }}>
                        {confirmed ? (
                            <><span style={{ color: '#ff0000' }}>확정된 보고서로 자산정보 수정이 불가합니다.</span></>
                        ) : (
                            <>
                                { (infoType === 'asset_hidden' && created_ymd === '0000') ? (
                                    <>
                                        <span style={{ color: '#0378c7', paddingRight: '20px' }}>※ 보안등급 : 기밀성+무결성+가용성 합계에 의하여 세팅됨.
                                            &nbsp;&nbsp;&nbsp;
                                            <Tag color={'volcano'}>High</Tag>
                                            <InputNumber name='assetGradeHeight'min={1} max={9} value={assetGradeHigh} size={'small'} style={{ width: '50px' }} onChange={onChangeGradeHigh} />이상
                                            &nbsp;&nbsp;
                                            &nbsp;&nbsp;
                                            <Tag color={'green'}>Low</Tag>
                                            <InputNumber name='assetGradeRow' min={1} max={9} value={assetGradeRow} size={'small'} style={{ width: '50px' }} onChange={onChangeGradeRow} />이하
                                            &nbsp;&nbsp;
                                            <Button type="default" onClick={() => handleGrade()}>
                                                보안등급 재설정
                                            </Button>
                                        </span>
                                    </>
                                ) : (infoType === 'asset' && !created_ymd) ? (
                                    <span style={{ color: '#0378c7', paddingRight: '20px' }}>※ 보안등급 : 기밀성+무결성+가용성 합계에 의하여 세팅됨.</span>
                                ) : (
                                    <span style={{ color: '#0378c7' }}></span>
                                )}
{/*                                 
                                {infoType == 'asset' ? (<></>) : (
                                    <input
                                        type="file"
                                        name="file"
                                        className='ant-btn-primary'
                                        style={{ padding: '4px 15px' }}
                                        onChange={onChangeUploadHandler}
                                        accept=".csv, .txt"
                                    />
                                )}
                                {showUpload ? (
                                    <Button type="default" onClick={() => onClickFileSaveHandler()}>
                                        Save
                                    </Button>
                                ) : (
*/}
                                { (infoType === 'asset' && created_ymd)  ? (
                                    <>
                                        <Button type="default" onClick={() => handleAdd()}>
                                            Add a row
                                        </Button>
                                        {/* <Button type="primary" onClick={()=>onClickSaveHandler(changeData.concat(deleteData))}> */}
                                        {/* <Button type="primary" onClick={() => saveData()}> */}
                                        <Button type="primary" onClick={() => onClickSaveHandler(changeData.concat(deleteData))}>
                                            Save
                                        </Button>
                                    </>
                                ) : (<></>)}

                                {selectedRowKeys && selectedRowKeys.length > 0 && (
                                    <Popconfirm 
                                        title={`선택한 ${selectedRowKeys.length}개의 자산을 삭제하시겠습니까?`}
                                        onConfirm={() => handleDeleteSelected()}
                                    >
                                        <Button type="default" danger style={{marginLeft: '5px', marginRight: '5px'}}>
                                            선택 삭제 ({selectedRowKeys.length}개)
                                        </Button>
                                    </Popconfirm>
                                )}

                                { ((infoType === 'measure') && created_ymd)  ? (
                                    <>
                                        <Button type="primary" onClick={() => onClickSaveHandler(changeData.concat(deleteData))}>
                                            Save
                                        </Button>
                                    </>
                                ) : (<></>)}
                                
                            </>
                        )}
                        <Button type="default" onClick={() => excelDownload(excel_title, dataSource, ['report_id'])}>
                            Excel Download
                        </Button>
                    </td>
                </tr></tbody>
            </table>
            {showUpload ? (
                <div className="section" id="uploadTable">
                    <Content style={{ height: 450, backgroundColor: '#fff', overflow: 'scroll' }}>
                        <table>
                            <thead>
                                <tr>
                                    {tableRows.map((rows, index) => {
                                        return <th key={index}>{rows}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {values.map((value, index) => {
                                    return (
                                        <tr key={index}>
                                            {value.map((val, i) => {
                                                return <td key={i}>{val}</td>;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Content>
                </div>
            ) : (
                <Form form={form} component={false}>
                    <Table
                        columns={mergedColumns}
                        dataSource={dataSource}
                        rowKey={rowIndex}
                        rowSelection={rowSelection}
                        loading={{
                            size: "large",
                            spinning: isLoading
                        }}
                        // rowKey="asset_cd"
                        pagination={false}
                        bordered size={"small"}
                        scroll={{ y: getGridTableHeight(450) }}
                        style={{ height: getGridTableHeight(420) }}
                        showSorterTooltip={false}
                        components={{
                            body: {
                                row: EditableRow,
                                cell: EditableCell,
                            },
                        }}
                        rowClassName={() => 'editable-row'}
                        // onRow={(record) => {
                        //     return {
                        //       style: {
                        //         background: record.status === 'c' ? '#e6f7ff' : 
                        //         record.status === 'u' ? '#cceeaa':'#fff1f0',
                        //       },
                        //     };
                        //   }}
                    />
                </Form>
            )}
        </>

    );
}
export default InfoTableAsset;